module.exports = __webpack_public_path__ + "img/vc.a390bb4b.svg";